import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {environment} from '@drl/env/environment';
import {Observable, of} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {map} from 'rxjs/operators';

import {AuthService} from './auth.service';
import {UserSessionStoreService as StoreService} from '../store/user-session-store.service';

@Injectable({
  providedIn: 'root',
})
export class OtpVerificationInGuard implements CanActivate {
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly store: StoreService,
  ) {}

  canActivate(): Observable<boolean> {
    return this.authService.isLoggedIn().pipe(
      map(isLoggedIn => {
        if (isLoggedIn) {
          this.router.navigate([environment.homePath]);
          return false;
        }

        if (!this.store.getUser()) {
          this.router.navigate(['/login']);
          return false;
        }

        return true;
      }),
      catchError(err => {
        console.error('Auth check failed:', err);

        if (!this.store.getUser()) {
          this.router.navigate(['/login']);
          return of(false);
        }
        return of(true);
      }),
    );
  }
}
